import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isStagingAlertEnabled: process.env.REACT_APP_SHOW_LIVE_CREDS_ALERT === "true",
};

const envSlice = createSlice({
  name: "env",
  initialState,
  reducers: {},
});

export default envSlice.reducer;
